import { uniqueId } from "@/views/zhiji/js/common/util.js";
import { ParamError } from "@/views/zhiji/js/common/errors.js";
import i18n from "@/i18n";

// 服务端链接类型转换
function tansUrlType2Server(url, urlType, newPage) {
    let type = "";
    if (!url) {
        type = "";
    } else {
        if (urlType === "innerColor") {
            type = "custom_page";
        }
        if (urlType === "outColor") {
            type = newPage || "";
        }
    }

    return type || "";
}

// 客户端链接类型转换
function tansUrlType2Client(urlType) {
    let type = "";
    if (urlType === "custom_page") {
        type = "innerColor";
    }
    if (urlType === "new_page" || urlType === "") {
        type = "outColor";
    }
    return type;
}

export default {
    widgetName: "Picture",
    serverType: "picture",
    initContent() {
        return {
            uId: uniqueId(),
            updateState: "add",
            wtType: "Picture",
            cardImage: "",
            descContent: "",
            redState: "off",
            redHotEndTime: "",
            hotItem: "NEW",
            image: "",
            resourceId: "0"
        };
    },
    checkContent(content) {
        if (!content.image) {
            throw new ParamError(i18n.t("zhiji.answer.uploadImageTips"));
        }
    },
    server2Client(content) {
        return {
            uId: uniqueId(),
            wtType: "Picture",
            updateState: "add",
            redState: "off",
            hotItem: "NEW",
            redHotEndTime: "",
            cardImage: content.card_image,
            descContent: content.name || "",
            image: content.image,
            resourceId: content.resource_id,
            url: content.url,
            urlType: tansUrlType2Client(content.url_type),
            newPage: content.url_type,
            urlCmd: content.url_cmd
                ? content.url_cmd.map(item => ({
                      key: item.key,
                      paramId: item.param_id,
                      source: item.source
                  }))
                : []
        };
    },
    client2Server(content) {
        return {
            type: "image",
            name: content.descContent,
            card_image: content.cardImage,
            image: content.image,
            resource_id: content.resourceId || "0",
            url: content.url, // 跳转url
            url_type: tansUrlType2Server(content.url, content.urlType, content.newPage), // new_page 新页面,url为h5页跳转地址。custom_page 自定义页面，url为app内链跳转地址
            url_cmd: content.urlCmd
                ? content.urlCmd.map(item => ({
                      key: item.key,
                      param_id: item.paramId,
                      source: item.source
                  }))
                : []
        };
    }
};
